import React from "react";
import {isFalsy, StaticFieldDisplayProps} from "../staticFieldUtils.ts";
import {
    FormError,
    FormLabel, getInputClassNames, getInputWrapperClass, getWholeDivWrapperClass, SUFFIX_CLASS,
} from "../../sharedStyles.tsx";
import {defaultParserForSelects} from "../../../dyanimcFormUtil.tsx";



const StaticDefaultDisplayRenderer: React.FC<StaticFieldDisplayProps> = ({ component, value, controller }) => {
    const { fieldState } = controller;
    const parsedValue = defaultParserForSelects(value);
    value = parsedValue && parsedValue?.label ? parsedValue.label : value;

    return (
        <div className={getWholeDivWrapperClass(component)}>
            <FormLabel component={component}></FormLabel>
            <div className={getInputWrapperClass(component) + (component.suffix && ' flex')}>
                    <span className={getInputClassNames(component, fieldState)}>
                            {isFalsy(value) ? "-" : value}
                    </span>
                {component.suffix &&
                    <span className={SUFFIX_CLASS.replace("text-sm", "text-xs")}>{component.suffix}</span>
                }
            </div>
            <FormError fieldState={fieldState} component={component}/>
        </div>
    );
};
export const StaticDefaultDisplay = React.memo(StaticDefaultDisplayRenderer);